import React from 'react';

export default function SSORequired() {
  return (
    <div style={{ paddingLeft: `1em` }}>
      <p>Hi there!</p>
      <p>
        Your organization is connected to Hud through SSO. Please{' '}
        <a href="/">go back to the login page</a> and input your email, thank
        you!
      </p>
    </div>
  );
}
